<template>
    <div>
        <label class="v-label theme--light pr-4">{{label}}</label>
        <div v-if="hint" v-text="hint" />
        <v-btn-toggle v-model="justify" @change="$emit('input', justify)" :mandatory="mandatory" color="zoezi-edit-color">
            <v-btn value="justify-start">
                <v-icon>mdi-format-align-left</v-icon>
            </v-btn>

            <v-btn value="justify-center">
                <v-icon>mdi-format-align-center</v-icon>
            </v-btn>

            <v-btn value="justify-space-around">
                <v-icon>mdi-format-align-justify</v-icon>
            </v-btn>

            <v-btn value="justify-end">
                <v-icon>mdi-format-align-right</v-icon>
            </v-btn>

        </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'AlignmentSetting',

    props: ['value', 'label', 'mandatory', 'hint'],
    data: () => ({
        justify: null
    }),
    created() {
        this.justify = this.value;
    }
}
</script>
